module.exports = __webpack_public_path__ + "img/logo.6efe2de5.png";